import WithBlockedModal from './withBlockedModal';

export default WithBlockedModal;
